import { Draggable } from "react-beautiful-dnd";
import { RemovableCard } from "../../cards";

import "./draggableFlowCard.scss";

function DraggableFlowCard(props) {
  const { id, title, index, type, onRemoveItemClick } = props;

  return (
    <Draggable draggableId={`draggable-flow-item-${id}`} index={index}>
      {(provided) => (
        <div
          className="draggable-item"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <RemovableCard id={id} title={title} type={type} onRemoveItemClick={onRemoveItemClick} />
        </div>
      )}
    </Draggable>
  );
}

export default DraggableFlowCard;
